import { ENUM_THIRD_PARTY_ACCESS_TYPE } from '@entities/types'

export interface UserProfile {
  username: string
  id: string
  email: string
  firstName: string
  lastName: string
  level: USER_LEVEL_ENUM
  notesAccess: boolean
  groupId: string
  isAutoAttach: boolean
  userType: string
  accessType?: ENUM_THIRD_PARTY_ACCESS_TYPE
  airlineId?: string
  airlineLabel?: string
}

export enum USER_LEVEL_ENUM {
  SUPER_ADMIN = 'SUPER_ADMIN',
  FLYDOCS_USER = 'FLYDOCS_USER',
  EXTERNAL_ENGINEER = 'EXTERNAL_ENGINEER',
  AIRLINES_USER = 'AIRLINES_USER',
  THIRD_PARTY_USER = 'THIRD_PARTY_USER',
}

export enum USER_GROUP_LEVEL {
  AIRLINES_USER = 'AIRLINES_USER',
  FLYDOCS_USER = 'FLYDOCS_USER',
  EXTERNAL_ENGINEER = 'EXTERNAL_ENGINEER',
  THIRD_PARTY_GROUP = 'THIRD_PARTY_GROUP',
}
export enum MAIN_USER_LEVEL_ENUM {
  SUPER_ADMIN = 'SUPER_ADMIN',
  AIRLINES_USER = 'AIRLINES_USER',
  FLYDOCS_USER = 'FLYDOCS_USER',
  THIRD_PARTY_USER = 'THIRD_PARTY_USER',
  EXTERNAL_ENGINEER = 'EXTERNAL_ENGINEER',
}
